import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import { BrandLogosWidgetItem } from 'JS/dxp/types/widgets';
import { useListSlider } from 'JS/composables/list-slider';
import { useViewportWidth } from 'JS/composables/breakpoint';
import { watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandLogosWidgetCarouselLayout',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
	items: BrandLogosWidgetItem[];
}



const { slider, viewport, previous, next } = useListSlider();

const viewportWidth = useViewportWidth();
watch(() => [viewportWidth.value, props.items], () => slider.value?.reset());


return { __sfc: true,props, slider, viewport, previous, next, viewportWidth, CarouselArrowButton }
}

})